var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mute",
    transform: "translate(-30 -191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(30 191)",
    fill: "rgba(0,0,0,0.3)",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 26.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(39.436 200.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M30.151,31.651,6,7.5",
    transform: "translate(-1.609 -2.011)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M19.986,11.811v2.313a.283.283,0,0,0,.081.2l1.647,1.647a.275.275,0,0,0,.468-.2V10.684A1.681,1.681,0,0,0,21.311,9.2a1.63,1.63,0,0,0-1.749.124.108.108,0,0,0-.044.037l-2.2,1.793a.291.291,0,0,0-.1.2.287.287,0,0,0,.081.2l1.171,1.171a.28.28,0,0,0,.373.022Z",
    transform: "translate(-4.618 -2.414)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M16.173,30.156l-5.357-4.384a2.194,2.194,0,0,0-1.391-.49H5.2V18.7H8.672a.275.275,0,0,0,.2-.468L7.223,16.581a.283.283,0,0,0-.2-.081H4.647A1.649,1.649,0,0,0,3,18.147v7.684a1.649,1.649,0,0,0,1.647,1.647H9.433l6.272,5.13a.108.108,0,0,0,.044.037,1.637,1.637,0,0,0,1.771.117,1.672,1.672,0,0,0,.849-1.478V27.836a.279.279,0,0,0-.081-.19L16.642,26a.275.275,0,0,0-.468.19ZM9.44,27.478Z",
    transform: "translate(-0.804 -4.424)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M31.8,22a10.53,10.53,0,0,0-1.215-4.889,1.1,1.1,0,0,0-1.961,1A8.392,8.392,0,0,1,29.6,22c0,.183-.007.366-.022.556a.536.536,0,0,0,.161.432l1.347,1.347a.27.27,0,0,0,.271.073.258.258,0,0,0,.19-.212A9.621,9.621,0,0,0,31.8,22Z",
    transform: "translate(-7.645 -4.432)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M37.394,20.787a14.951,14.951,0,0,0-2.342-8.241,1.1,1.1,0,0,0-1.9,1.112A12.675,12.675,0,0,1,35.2,20.787a12.506,12.506,0,0,1-.644,4.164.552.552,0,0,0,.132.564l1.149,1.149a.265.265,0,0,0,.249.073.26.26,0,0,0,.2-.161A14.246,14.246,0,0,0,37.394,20.787Z",
    transform: "translate(-8.851 -3.222)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M42.988,19.575A19.654,19.654,0,0,0,39.519,8,1.1,1.1,0,1,0,37.668,9.19a17.621,17.621,0,0,1,3.125,10.385,17.2,17.2,0,0,1-1.617,7.75.277.277,0,0,0,.051.315l1.222,1.222a.275.275,0,0,0,.242.081.27.27,0,0,0,.2-.146A19.286,19.286,0,0,0,42.988,19.575Z",
    transform: "translate(-10.055 -2.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M0,0H35.129V35.129H0Z",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteButton);
export default __webpack_public_path__ + "static/media/MuteButton.8ed599a4b2fc970af601da27ab8fb8d0.svg";
export { ForwardRef as ReactComponent };